<template lang="html">
  <v-content>
    <section>
      <v-img
        src="https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
        :gradient="gradient"
        height="450">
        <v-container grid-list-xl fill-height>
          <v-layout align-center>
            <v-flex text-xs-center>
              <h2 class="font-weight-black white--text" style="font-size:50px">ติดต่อเรา</h2>
              <h4 class="font-weight-black white--text" style="font-size:30px">เราพร้อมที่สุดเรื่องเฟอร์นิเจอร์</h4>
            </v-flex>
          </v-layout>
        </v-container>
      </v-img>
      <v-card>
        <v-container grid-list-xl text-xl-center>
          <v-card-title primary-title>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout column align-center>
                  <v-flex xs12>
                    <h5 class="font-weight-medium" style="font-size:25px">บริษัท แน็กส์ เฟอร์นิชิ่ง จำกัด (Naics Furnishing Co., Ltd.)</h5>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row align-center>
                  <v-flex xs2><v-icon size="30px" color="blue darken-2">fas fa-map-marker-alt</v-icon></v-flex>
                  <v-flex xs10><p class="font-weight-regular" style="font-size:18px">22/6 หมู่ 1  ตำบลดอนลาน อำเภอผักไห จังหวัดพระนครศรีอยุธยา 13280 ประเทศไทย</p></v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row align-center>
                  <v-flex xs2><v-icon size="30px" color="blue darken-2">fas fa-envelope</v-icon></v-flex>
                  <v-flex xs10><p class="font-weight-regular" style="font-size:18px">kawin@naicsfurnishing.com</p></v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row align-center>
                  <v-flex xs2><v-icon size="30px" color="blue darken-2">fas fa-phone</v-icon></v-flex>
                  <v-flex xs10><p class="font-weight-regular" style="font-size:18px"><a href="tel:035-795-113">035-795-113</a>, <a href="tel:081-763-2077">081-763-2077</a></p></v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12>
                <v-layout row align-center>
                  <v-flex xs2><v-icon size="30px" color="blue darken-2">fas fa-globe</v-icon></v-flex>
                  <v-flex xs10>
                    <p class="font-weight-regular" style="font-size:20px"><v-icon size="30px" color="light-green accent-4">fab fa-line</v-icon> line</p>
                    <p class="font-weight-regular" style="font-size:20px"><v-icon size="30px" color="blue darken-2">fab fa-facebook</v-icon> facebook</p>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-container>
      </v-card>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout justify-center column fill-height>
          <v-flex xs12>
            <h2 class="text-md-center font-weight-medium blue--text text--darken-4" style="font-size:30px">แผนที่</h2>
            <v-flex xs12>
              <div align="center">
                <v-img
                  :src="require('@/assets/NF_Map_final.jpg')"
                  :lazy-src="require('@/assets/NF_Map_final.jpg')"
                  aspect-ratio="1.3"
                  contain
                  class="white">
                </v-img>
              </div>
            </v-flex>
            <v-flex xs12>
              <v-layout row justify-center>
                <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                  <v-btn slot="activator" color="primary" large outline round block dark>Click เพื่อดูแผนที่เต็ม  <v-icon>zoom_in</v-icon></v-btn>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-toolbar-title>แผนที่</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-toolbar-items>
                        <v-btn icon dark @click.native="dialog = false">
                          <v-icon>close</v-icon>
                        </v-btn>
                      </v-toolbar-items>
                    </v-toolbar>
                    <v-card-text>
                      <v-container grid-list-md>
                        <v-layout wrap>
                          <v-flex xs12>
                            <div align="center">
                              <v-img
                                :src="require('@/assets/NF_Map_final.jpg')"
                                :lazy-src="require('@/assets/NF_Map_final.jpg')"
                                aspect-ratio="1.7"
                                contain
                                class="white">
                              </v-img>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-btn color="red darken-1" dark block round @click.native="dialog = false">Clikc เพื่อปิดแผนที่ <v-icon>zoom_out</v-icon></v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-layout>
            </v-flex>
          </v-flex>
          <v-flex xs12>
            <!-- <h4 class="text-md-center font-weight-medium" style="font-size:30px">สอบถามข้อมูลเพิ่มเติม</h4> -->
            <v-flex xs12>
              <div align="center">
                <v-card>
                  <v-card-title class="blue darken-4 white--text" style="font-size:26px" primary-title>
                    สอบถามข้อมูลเพิ่มเติม
                  </v-card-title>
                  <v-card-text>
                    <v-alert
                      v-model="alert"
                      dismissible
                      :type="alertType"
                      transition="scale-transition"
                    >
                      {{this.alertValue}}
                    </v-alert>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-form ref="form" v-model="valid" lazy-validation>
                          <v-text-field
                            v-model="name"
                            :rules="nameRules"
                            :counter="25"
                            label="ชื่อ-นามสกุล (จำเป็น)"
                            required>
                          </v-text-field>
                          <v-text-field
                            v-model="email"
                            :rules="emailRules"
                            label="E-mail (จำเป็น)"
                            required
                          ></v-text-field>
                          <v-text-field
                            v-model="company"
                            label="บริษัท"
                          ></v-text-field>
                          <v-text-field
                            v-model="topic"
                            label="เรื่อง"
                          ></v-text-field>
                          <v-textarea
                            name="input-7-1"
                            v-model="message"
                            label="ข้อความ"
                            auto-grow
                          ></v-textarea>
                          <v-checkbox
                            v-model="checkbox"
                            :rules="[v => !!v || 'กรุณา click เพื่อยืนยันข้อมูลก่อนส่ง!']"
                            label="กรุณา click เพื่อยืนยันข้อมูล?"
                            required
                          ></v-checkbox>
                          <v-btn
                            :disabled="!valid"
                            @click="submit"
                            color="primary"
                            :loading="loading"
                          >
                            ส่งข้อความ
                          </v-btn>
                          <v-btn @click="clear">ยกเลิก</v-btn>
                        </v-form>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </div>
            </v-flex>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section>
      <v-layout row>
        <map-location></map-location>
      </v-layout>
    </section>
  </v-content>
</template>

<script>
import axios from 'axios'
import MapLocation from '../map.vue'
export default {
  components: {
    MapLocation
  },
  data: () => ({
    gradient: 'to top right, rgba(20,81,181,.8),rgba(15,32,72,.7)',
    valid: true,
    loading: false,
    name: '',
    nameRules: [
      v => !!v || 'กรุณากรองชื่อของคุณ',
      v => (v && v.length <= 25) || 'Name must be less than 25 characters'
    ],
    email: '',
    emailRules: [
      v => !!v || 'กรุณากรองE-mailของคุณ',
      v => /.+@.+/.test(v) || 'E-mail must be valid'
    ],
    company: '',
    topic: '',
    message: '',
    checkbox: false,
    alert: false,
    alertValue: '',
    alertType: 'warning',
    dialog: false,
    notifications: false,
    sound: true,
    widgets: false
  }),
  methods: {
    submit () {
      if (this.$refs.form.validate()) {
        this.loading = true
        // need to change when deploy
        // axios.post('http://localhost:5000/game-project-d33f1/us-central1/hellofirebaseNew', {
        axios.post('https://us-central1-game-project-d33f1.cloudfunctions.net/hellofirebaseNew', {
          name: this.name,
          email: this.email,
          company: this.company,
          topic: this.topic,
          message: this.message
        }).then((response) => {
          var alertStatue = true
          var alertValue = 'อีเมลถูกส่งเรียบร้อย!'
          var alertType = 'success'
          this.setAlert(alertStatue, alertValue, alertType)
        }).catch((error) => {
          console.log(error)
          var alertStatue = true
          var alertValue = 'มีข้อผิดพลาดในการส่งอีเมล!'
          var alertType = 'warning'
          this.setAlert(alertStatue, alertValue, alertType)
        })
      }
    },
    clear () {
      this.$refs.form.reset()
    },
    setAlert (alert, alertVal, alertT) {
      this.alert = alert
      this.alertValue = alertVal
      this.alertType = alertT
      this.loading = false
      this.clear()
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/mobile/contactUsMobile.vue